<div
  class="innerBanner"
  [ngStyle]="{ backgroundImage: 'url(../../assets/images/notfoundBG.avif)' }"
  style="min-height: 700px"
>
  <div class="bannerText">
    <p class="notfoundBannerData">{{ 'Oh no!' | translate }}</p>
    <p class="notfoundBannerData">{{ 'There is Trouble In Paradise' | translate }}</p>
    <div style="text-align: center">
      <span class="cocoData">4</span>
      <img class="cocoImage" src="../../assets/images/coco.png" alt="coco" />
      <span class="cocoData">4</span>
    </div>
    <p class="BannerlostData">{{ 'The page you were looking for seems to be lost' | translate }}</p>
    <span style="text-align: center">
      <a
        href="/home"
        class="btn rounded-pill btn-lg active"
        role="button"
        aria-pressed="true"
        style="background-color: white; color: #00a7a6"
        >{{ 'Back to Home' | translate }}</a
      >
    </span>
  </div>
</div>
